import React from 'react';
import { Checkbox, makeStyles, withStyles } from '@material-ui/core';
import moment from 'moment';
import config from '@/configs/config';
import CountTextField from '../../../preorder/components/CountTextField';

const DATE_FORMAT = 'MM/DD (dd) HH:mm';

export const StyledCheckbox = withStyles({
  root: {
    '&$checked': {
      color: '#000000',
    },
  },
  checked: {},
})(Checkbox);

const useStyles = makeStyles((theme) => ({
  root: {
    display: 'flex',
    background: '#f2f2f2',
    position: 'relative',

    '&+&': {
      marginTop: theme.spacing(1.5),
    },
  },
  checkboxContainer: {
    flexShrink: 0,
    padding: theme.spacing(5, 0),
  },
  body: {
    flexGrow: 1,
    display: 'flex',
    flexDirection: 'column',
    alignItems: 'stretch',
    padding: theme.spacing(2),
    paddingRight: theme.spacing(4),

    [theme.breakpoints.up('sm')]: {
      flexDirection: 'row',
    },
  },
  footer: {
    display: 'none',
    width: 240,
    background: '#e9e9e9',

    [theme.breakpoints.up('sm')]: {
      display: 'flex',
    },
  },
  footerItem: {
    alignItems: 'center',
    display: 'flex',
    flexBasis: 0,
    flexDirection: 'column',
    flexGrow: 1,
    flexShrink: 0,
    justifyContent: 'center',
    padding: theme.spacing(1),
    position: 'relative',
    width: 120,
  },
  productInfo: {
    display: 'flex',

    [theme.breakpoints.up('sm')]: {
      flexGrow: 1,
      flexBasis: 0,
    },
  },
  mid: {
    alignItems: 'center',
    display: 'flex',
    flexDirection: 'column',
    flexShrink: 0,
    width: '100px',
  },
  pictureContainer: {
    paddingBottom: '100%',
    position: 'relative',
    width: '100%',
  },
  picture: {
    top: 0,
    left: 0,
    position: 'absolute',
    width: '100%',
    height: '100%',
  },
  infoContainer: {
    display: 'flex',
    flexDirection: 'column',
    flexGrow: 1,
    marginLeft: theme.spacing(1),
  },
  removeButton: {
    outline: 'none',
    textDecoration: 'underline',
    border: 0,
    background: 'none',

    [theme.breakpoints.up('sm')]: {
      display: 'none',
    },
  },
  countContainer: {
    display: 'flex',
    justifyContent: 'space-between',
    marginTop: theme.spacing(1),

    [theme.breakpoints.up('sm')]: {
      display: 'none',
    },
  },
  totalPrice: {
    color: '#a80000',
    fontWeight: 'bold',

    [theme.breakpoints.up('sm')]: {
      color: 'black',
    },
  },
  mask: {
    position: 'absolute',
    top: 0,
    left: 0,
    width: '100%',
    height: '100%',
    background: '#ffffff',
    opacity: 0.5,
    zIndex: 10,
  },
  redeemInfo: {
    marginTop: theme.spacing(1),

    [theme.breakpoints.up('sm')]: {
      marginTop: 0,
      flexGrow: 1,
      flexBasis: 0,
    },
  },
}));

const useDisplayFieldStyles = makeStyles(() => ({
  root: {
    fontSize: 13,
    color: '#a80000',
  },
}));

const DisplayField = ({ label, value }) => {
  const classes = useDisplayFieldStyles();
  return (
    <div className={classes.root}>
      <div className={classes.label}>
        {`${label}：`}
      </div>
      <div className={classes.value}>
        {value}
      </div>
    </div>
  );
};

export default ({
  amount,
  checked,
  data,
  disabled,
  isReadOnly,
  onAddButtonClick,
  onCheckboxChange: propsOnCheckboxChange,
  onRemoveButtonClick,
  onSubButtonClick,
}) => {
  const classes = useStyles();
  const {
    name,
    provider,
    productNumber,
    redeemEndTime,
    redeemStartTime,
    fridgeName,
    fridgeAddress,
    price,
    sellPrice,
  } = data || {};

  const totalPrice = (sellPrice || price) * amount;
  const redeemStartString = moment(redeemStartTime).utcOffset(8).format(DATE_FORMAT);
  const redeemEndString = moment(redeemEndTime).utcOffset(8).format(DATE_FORMAT);
  const onCheckboxChange = (_e, newValue) => {
    propsOnCheckboxChange(newValue);
  };

  return (
    <div className={classes.root}>
      {!isReadOnly && (
        <div className={classes.checkboxContainer}>
          <StyledCheckbox
            onChange={onCheckboxChange}
            disabled={disabled}
            checked={checked}
          />
        </div>
      )}
      <div className={classes.body}>
        <div className={classes.productInfo}>
          <div className={classes.mid}>
            <div className={classes.pictureContainer}>
              <img
                className={classes.picture}
                src={`${config.RESOURCE_URI}/ProductImages/${productNumber}.jpg`}
                alt=""
                onError={(e) => {
                  e.currentTarget.src = `${config.RESOURCE_URI}provider_default.png`;
                }}
              />
            </div>
            {!isReadOnly && (
            <button
              className={classes.removeButton}
              onClick={onRemoveButtonClick}
              type="button"
            >
              移出餐籃
            </button>
            )}
          </div>
          <div className={classes.infoContainer}>
            <div>{`【${provider}】${name}`}</div>
            <div className={classes.countContainer}>
              {isReadOnly ? (
                <div>
                  {`訂購數量： ${amount}`}
                </div>
              ) : (
                <div style={{ width: 130 }}>
                  <CountTextField
                    blackTonedStyle
                    defaultValue={amount}
                    minValue={1}
                    onChange={(value) => {
                      if (value - amount > 0) onAddButtonClick();
                      if (value - amount < 0) onSubButtonClick();
                    }}
                  />
                </div>
              )}
              <div className={classes.totalPrice}>{`$${totalPrice}`}</div>
            </div>
          </div>
        </div>
        <div className={classes.redeemInfo}>
          <DisplayField
            label="取貨時間"
            value={(
              <>
                <div>{`${redeemStartString} ~ ${redeemEndString}`}</div>
                <div>(實際取貨時間請以LINE 貨到通知為準)</div>
              </>
            )}
          />
          <DisplayField
            label="取貨地點"
            value={(
              <>
                <div>
                  {fridgeName}
                </div>
                <div>
                  {fridgeAddress}
                </div>
              </>
            )}
          />
        </div>
      </div>
      <div className={classes.footer}>
        <div className={classes.footerItem}>
          {isReadOnly
            ? amount
            : (
              <>
                <div>
                  <CountTextField
                    blackTonedStyle
                    defaultValue={amount}
                    minValue={1}
                    onChange={(value) => {
                      if (value - amount > 0) onAddButtonClick();
                      if (value - amount < 0) onSubButtonClick();
                    }}
                  />
                </div>
                <button
                  className={classes.removeButton}
                  onClick={onRemoveButtonClick}
                  style={{ position: 'absolute', bottom: 10, display: 'inline' }}
                  type="button"
                >
                  移出餐籃
                </button>
              </>
            )}
        </div>
        <div className={classes.footerItem}>
          <div className={classes.totalPrice}>{`$${totalPrice}`}</div>
        </div>
      </div>
    </div>
  );
};
